"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fallbackRules = exports.Config = void 0;
var RuleItem_1 = require("../config/RuleItem");
// @ts-ignore
var fallbackRules_json_1 = __importDefault(require("../fallbackRules.json"));
exports.fallbackRules = fallbackRules_json_1.default;
var Config = /** @class */ (function () {
    function Config(config) {
        var _this = this;
        if (config === void 0) { config = fallbackRules_json_1.default; }
        this.items = new Map();
        config.forEach(function (ruleItem) {
            var item = RuleItem_1.RuleItem.build(ruleItem);
            _this.items.set(item.pattern, item);
        });
    }
    Config.prototype.getRuleConfigs = function (key) {
        var handlerConfigs = [];
        this.items.forEach(function (ruleItem, pattern) {
            var _a;
            ((_a = key === null || key === void 0 ? void 0 : key.match) === null || _a === void 0 ? void 0 : _a.call(key, pattern)) ? handlerConfigs.push(ruleItem) : null;
        });
        return handlerConfigs;
    };
    // eslint-disable-next-line default-param-last
    Config.fromJson = function (rawConfig, logger) {
        if (rawConfig === void 0) { rawConfig = ''; }
        var config;
        try {
            config = JSON.parse(rawConfig);
        }
        catch (e) {
            Config.logError(e, logger);
            config = fallbackRules_json_1.default;
        }
        return Config.fromArray(config);
    };
    // eslint-disable-next-line default-param-last
    Config.fromArray = function (rawConfig, logger) {
        if (Array.isArray(rawConfig)) {
            return new Config(rawConfig);
        }
        Config.logError('Config is not array', logger);
        return new Config(fallbackRules_json_1.default);
    };
    Config.logError = function (err, logger) {
        var _a;
        (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, err);
    };
    return Config;
}());
exports.Config = Config;
//# sourceMappingURL=Config.js.map